"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPlacementSlipCDDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_placement_slip_generation_entity_1 = require("./opportunity-placement-slip-generation.entity");
let OpportunityPlacementSlipCDDetail = class OpportunityPlacementSlipCDDetail {
};
exports.OpportunityPlacementSlipCDDetail = OpportunityPlacementSlipCDDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "placement_slip_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "placementSlipId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "payment_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "paymentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cd_account_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "cdAccountTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "account_name", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPlacementSlipCDDetail.prototype, "accountName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "open_balance", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "openBalance", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "select_cd_account", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "selectCdAccount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "transaction_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "transactionTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cheque_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityPlacementSlipCDDetail.prototype, "chequeDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cheque_amount", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "chequeAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cheque_number", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPlacementSlipCDDetail.prototype, "chequeNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "bank_name", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPlacementSlipCDDetail.prototype, "bankName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCDDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityPlacementSlipCDDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityPlacementSlipCDDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration, (placement) => placement.cdDetails),
    (0, typeorm_1.JoinColumn)({ name: "placement_slip_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration !== "undefined" && opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration) === "function" ? _d : Object)
], OpportunityPlacementSlipCDDetail.prototype, "placementSlip", void 0);
exports.OpportunityPlacementSlipCDDetail = OpportunityPlacementSlipCDDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_placement_slip_cd_detail")
], OpportunityPlacementSlipCDDetail);
